/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One video in the hero strip. Assigned by URL so official highlights can live on YouTube, Twitch or Kick.
 * @export
 * @interface DropVideo
 */
export interface DropVideo {
    /**
     * 
     * @type {string}
     * @memberof DropVideo
     */
    url: string;
    /**
     * Publisher's label for the tile. Falls back to a resolved title.
     * @type {string}
     * @memberof DropVideo
     */
    title?: string;
    /**
     * Runtime, when the platform reported one. Absent rather than guessed.
     * @type {number}
     * @memberof DropVideo
     */
    durationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof DropVideo
     */
    thumbnailUrl?: string;
}

/**
 * Check if a given object implements the DropVideo interface.
 */
export function instanceOfDropVideo(value: object): value is DropVideo {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function DropVideoFromJSON(json: any): DropVideo {
    return DropVideoFromJSONTyped(json, false);
}

export function DropVideoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropVideo {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'title': json['title'] == null ? undefined : json['title'],
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
    };
}

export function DropVideoToJSON(json: any): DropVideo {
    return DropVideoToJSONTyped(json, false);
}

export function DropVideoToJSONTyped(value?: DropVideo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'title': value['title'],
        'durationSeconds': value['durationSeconds'],
        'thumbnailUrl': value['thumbnailUrl'],
    };
}

